// Copyright ©️ 2026 eVolve MEP, LLC

import { ManageCustomPropertiesButton } from 'components/Mantine/CustomProperties/ManageCustomPropertiesButton';
import { useHasAccess } from 'hooks/user/useHasAccess';

import { useMachineElementActionsModals } from './machineElementActions/modalRegistry';

type Props = {
  disabled?: boolean;
  actionIcon?: boolean;
};

/** Opens machine element custom properties using the machine element modal registry */
export const ManageBendCustomProperties = ({ actionIcon, disabled }: Props) => {
  const { openModal } = useMachineElementActionsModals();
  const hasCustomPropertiesAccess = useHasAccess('customProperties', 'write');

  return (
    <ManageCustomPropertiesButton
      actionIcon={actionIcon}
      disabled={disabled || !hasCustomPropertiesAccess}
      onClick={() => openModal('ManageBendCustomPropertiesModal')}
    />
  );
};
